// eslint-disable-next-line import/prefer-default-export
export const SEND_CONTACT_FORM = 'sendContactForm';
